import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const KEY = "table-state";

const stripParams = (search: string, ignoredParams?: string[]) => {
  if (!ignoredParams?.length) {
    return search;
  }

  const params = new URLSearchParams(search);
  ignoredParams.forEach((param) => params.delete(param));
  const stripped = params.toString();

  return stripped ? `?${stripped}` : "";
};

export const useStoredTableState = (id: string, ignoredParams?: string[]) => {
  const { location } = useHistory();
  const state = decodeURI(localStorage.getItem(`${KEY}/${id}`) || "");
  const search = stripParams(location.search, ignoredParams);

  if (search) {
    return search;
  }

  return state && state.length > 0 ? state : undefined;
};

export const storeTableState = (id?: string) => {
  const history = useHistory();

  useEffect(() => {
    if (!id) {
      return;
    }

    localStorage.setItem(`${KEY}/${id}`, history.location.search);
  }, [history.location.search]);
};
